import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TicketPercent, Gem, Ban, X } from "lucide-react";
import { useTranslations } from "next-intl";

export default function Tag({
  discount,
  isOutOfStock,
  isHidden = null,
  className,
}) {
  let type;
  const t = useTranslations("promo");

  if (isHidden) type = "hidden";
  else if (isOutOfStock) type = "outOfStock";
  else if (discount.type === "none") return;
  else type = discount.type;

  const renderIconAndText = () => {
    switch (type) {
      case "outOfStock":
        return (
          <>
            <Ban className="w-4 text-white" /> {t("outStock")}
          </>
        );
      case "gift":
      case "sale":
        return (
          <>
            <Gem className="w-4 text-white" /> {t("offer")}
          </>
        );
      case "discount":
        return (
          <>
            <TicketPercent className="w-4 text-white" /> {t("discount")}
          </>
        );
      case "hidden":
        return (
          <>
            <X className="w-4 text-white" /> Masqué
          </>
        );
      default:
        return "Invalid badge";
    }
  };
  return (
    <Badge
      variant="destructive"
      className={cn("absolute right-0 top-0 gap-2", className)}
    >
      {renderIconAndText()}
    </Badge>
  );
}
